import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentWithoutEdit } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { GoodsTransferDetailsschemaObject } from "../GoodsTransferDetailsSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _ from 'lodash';

const screenCode = "GOODSTRANSFERDETAILS";

export function GoodsTransferDetails(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [gtnnumber, setGtnnumber] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [goodsTransferDetails, setGoodsTransferDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        searchDate: "",
        gtnnumber: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        searchDate: "",
        gtnnumber: "0"
    })
    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(GoodsTransferDetailsschemaObject).options({ allowUnknown: true });
    const contentRowNames = ["fieldName", "totalAmount", "deduction", "netAmount", "bagCount"]
    const csvHeaders = [
        { label: "Field Name", value: "fieldName" },
        { label: "Gross Amount (Kg)", value: "totalAmount" },
        { label: "Deduction (Kg)", value: "deduction" },
        { label: "Net Amount (Kg)", value: "netAmount" },
        { label: "Bag Count", value: "bagCount" }
    ];

    const [reportData, setReportData] = useState([]);
    const [keys, setKeys] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [goodsTransferDetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown()
        )
    }, [goodsTransferDetails.estateID])

    useEffect(() => {
        trackPromise(
            getGtnNumberForDropDown()
        )
    }, [goodsTransferDetails.searchDate])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            gtnnumber: "0"

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            estateID: target.value,
            divisionID: "0",
            gtnnumber: "0"

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            divisionID: target.value,
            gtnnumber: "0"

        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            searchDate: target.value,
            gtnnumber: "0"

        });
    }

    function handleGtnChange(target) {

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            gtnnumber: target.value

        });
    }


    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, GoodsTransferDetailsschemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGOODSTRANSFERDETAILS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }


    function destroyDataTable() {
        keys.forEach(e => {
            $(`#${e}`).DataTable().destroy();
        })
    }

    function createDataTable() {
        keys.forEach(e => {
            $(`#${e}`).DataTable();
        })
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(goodsTransferDetails.groupID);
        setEstates(data);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(goodsTransferDetails.estateID);
        setDivisions(data);
    }

    async function getGtnNumberForDropDown() {
        const data = await services.getGtnNumberByCollectionPointIDandDate(goodsTransferDetails);
        setGtnnumber(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();

        setIsTableHide(true);

        setButtonHide(true);

        const errorMessages = validate(schema, goodsTransferDetails);

        errorMessages !== null ? setErrors(errorMessages) : setErrors({});

        if (errorMessages) return;

        getSelectedDropdownValuesForReport(goodsTransferDetails);

        setIsTableHide(true);

        const result = await services.getGoodsTransferDetails(goodsTransferDetails);

        let groupedResult = groupByGtn(result);
        let keys = Object.keys(groupedResult);

        setKeys(keys);
        setReportData(groupedResult);

        if (result.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }


        setButtonHide(false);
        setIsReportButtonsEnabled();

        const comlpeteData = [...result];
        setCsvData(comlpeteData)
    }

    function createFile() {
        var settings = {
            sheetName: 'GTN details report',
            fileName: 'GTNDetailsReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            fieldName: "Group :" + groups[goodsTransferDetails.groupID],
            totalAmount: "Estate : " + estates[goodsTransferDetails.estateID],
            deduction: "Division : " + divisions[goodsTransferDetails.divisionID],
            netAmount: "Date : " + goodsTransferDetails.searchDate,
            bagCount: "GTN Number : " + goodsTransferDetails.gtnnumber
        }
        copyOfCsv.push({}, {}, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            date: searchForm.searchDate,
            gtnnumber: gtnnumber[searchForm.gtnnumber]
        })
    }

    function groupByGtn(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['gtnNumber']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Goods Transfer Details"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={goodsTransferDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={goodsTransferDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={goodsTransferDetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="gtnnumber">GTN Number </InputLabel>
                                        <Select fullWidth
                                            id="gtnnumber"
                                            name="gtnnumber"
                                            value={goodsTransferDetails.gtnnumber}
                                            onChange={(e) => handleGtnChange(e.target)}>
                                            <MenuItem value="0">--Select GTN--</MenuItem>
                                            {generateDropDownMenu(gtnnumber)}
                                        </Select>

                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="table-responsive row-top-gap" >
                                        {keys.map((e, index) => {
                                            return (
                                                <div key={index} className="card shadow-none bg-light">
                                                    <div className="row alternative_cls bg-light  ">
                                                        <div className="card-body width1"><p><b><p />GTN number:</b><br /><br />  {reportData[e][0].gtnNumber}</p> </div>
                                                        <div className="card-body width2"><p><b><p />Division Name </b><br /><br />{reportData[e][0].collectionPointName} </p> </div>
                                                        <div className="card-body width3"><p><b><p />Transferred To </b><br /><br />{reportData[e][0].transferedTo}</p> </div>
                                                        <div className="card-body width3"> <p><b><p />Transfer Note:</b><br /><br />  {reportData[e][0].transferNote}</p></div>
                                                        <div className="card-body width4">
                                                            <table className="display dataTable no-footer" id={e}>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Field Name</th>
                                                                        <th>Gross Amount (Kg)</th>
                                                                        <th>Deduction (Kg)</th>
                                                                        <th>Net Amount (Kg)</th>
                                                                        <th>Bag Count</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <TableContentWithoutEdit
                                                                        data={reportData[e]}
                                                                        contentRowNames={contentRowNames}
                                                                        hasEdit={false}
                                                                    />
                                                                </tbody>
                                                            </table>
                                                        </div>


                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>


                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Goods Transfer Details"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
